import AddIcon from "@mui/icons-material/Add";
import { Card, Grid, Typography } from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../../components/CustomButton";
import CustomModal from "../../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../../components/CustomTextField";
import {
  clearInpatientSummary,
  getInpatientSummaryByAppointmentIdWoLoader,
  updateInpatientInstructions,
} from "../../../../redux/reducers/clinicSlice";
import { addIcon } from "../../../../util/CommonIconStyle";
import { getRightSaluation } from "../../../../util/function";
import { canWriteModule } from "../../../../util/roleModuleAccess";

const Instructions = () => {
  const dispatch = useDispatch();
  const canManageDashboard = canWriteModule("dashboard");
  const [text, setText] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);
  const [modVsble, setModVsble] = useState(false);
  const [instModVsble, setInstModVsble] = useState(false);
  const clinicVets = useSelector((state) => state?.vet?.vets?.vets);
  const reqDet = useSelector((state) => state?.pet?.complaintSummary?.data);
  const { inpatientSummary } = useSelector((state) => state?.clinic);
  const user = localStorage.getItem("user");
  const profile = JSON.parse(user);
  const petAndApntData = useSelector(
    (state) => state?.pet?.petAndAppointmentDetails,
  );

  useEffect(() => {
    if (
      petAndApntData?.appointment?.appointmentId &&
      petAndApntData?.appointment?.inpatient
    ) {
      onApiCall();
    }
    return () => {
      dispatch(clearInpatientSummary());
    };
  }, [
    petAndApntData?.appointment?.appointmentId,
    petAndApntData?.appointment?.inpatient,
  ]);

  const onApiCall = () => {
    dispatch(
      getInpatientSummaryByAppointmentIdWoLoader(
        petAndApntData?.appointment?.appointmentId,
      ),
    );
    // dispatch(getPetsCompliantSummary(reqDet?.appointment?.appointmentId));
  };

  const getVetName = (vetId, checkIsDoctor = false) => {
    const vetName = clinicVets?.find((vet) => vet?.doctorId === vetId)?.name;
    if (checkIsDoctor) return vetName ? true : false;
    return vetName ?? profile?.name;
  };

  const handleSend = () => {
    if (text?.length === 0 || !petAndApntData?.inpatientResponse?.patientId)
      return;
    const reqObj = {
      patientId: petAndApntData?.inpatientResponse?.patientId,
      doctorId: profile?.id,
      text,
    };
    if (selectedItem?.summaryId) reqObj.summaryId = selectedItem?.summaryId;
    dispatch(updateInpatientInstructions(reqObj)).then((res) => {
      if (res?.payload) {
        onApiCall();
        onCloseMod();
      }
    });
  };

  const handleAddUpdateInstructions = (itm = null) => {
    if (itm) setSelectedItem(itm);
    setText(itm?.instructions ?? "");
    setModVsble(true);
  };

  const onCloseMod = () => {
    setModVsble(false);
    setText("");
  };

  return (
    <>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <div className="cardWHeader br8 bg-body mt15 pt10 pb10 pl15 pr15 mh10">
          <div className="flex-row-between">
            <Typography className="fs13 txt-semi-bold clr-dark-gray">
              Instructions
            </Typography>
            <div className="flex-row-ali-cen">
              {canManageDashboard ? (
                <div
                  className="flex-row-ali-cen cursor"
                  onClick={() => handleAddUpdateInstructions(null)}
                >
                  <div className="flex-center plus-icon">
                    <AddIcon sx={addIcon} />
                  </div>
                  <Typography className="blue-color fs14 ml5 font-bold">
                    Add
                  </Typography>
                </div>
              ) : null}
              {/* <Typography
                className="blue-color fs12 txt-semi-bold underline cursor ml15"
                onClick={() => setInstModVsble(true)}
              >
                View Updates
              </Typography> */}
            </div>
          </div>
          {[...(inpatientSummary ?? [])]
            ?.sort((a, b) => {
              const aTime = new Date(a?.createdDate || 0).getTime();
              const bTime = new Date(b?.createdDate || 0).getTime();
              if (bTime !== aTime) return bTime - aTime;
              return Number(b?.summaryId ?? 0) - Number(a?.summaryId ?? 0);
            })
            ?.map((inp) => {
              return (
                <Card
                  sx={{ borderColor: "#FFFFFF", padding: 2 }}
                  key={inp?.summaryId}
                  className=" mt15"
                >
                  <div className="flex-row">
                    <div className="w70Per">
                      <Typography className="blue-color fs14 font-bold">
                        {/* {getVetName(inp?.doctorId, true) ? "Dr " : ""} */}
                        {getRightSaluation(clinicVets, inp?.doctorId)}
                        {getVetName(inp?.doctorId)}
                      </Typography>
                      <Typography className="gray13 fs10 font-medium">
                        {moment(inp?.createdDate).format("DD MMM YYYY | HH:mm")}
                      </Typography>
                    </div>
                    <div className="w30Per">
                      <div className="flex1-end">
                        {inp?.doctorId ===
                        petAndApntData?.appointment?.doctorId ? (
                          <Typography className="dark-red fs10 font-bold org-back ph15 pv5 br5">
                            Attending Vet’s Instructions
                          </Typography>
                        ) : null}
                      </div>
                    </div>
                  </div>
                  <div className="flex-row mt5">
                    <div className="w90Per">
                      <Typography className="black29 fs14 txt-regular">
                        {inp?.instructions}
                      </Typography>
                    </div>
                    <div className="flex1-end">
                      {canManageDashboard ? (
                        <img
                          src={require("../../../../assets/images/png/edit-new.png")}
                          alt=""
                          className="img-wh20 cursor"
                          onClick={() => handleAddUpdateInstructions(inp)}
                        />
                      ) : null}
                    </div>
                  </div>
                </Card>
              );
            })}
        </div>

        {/* <div className="flex-row-ali-cen pos-rel">
          <Typography className="font-bold flex1-center fs14">
            Instructions
          </Typography>
          <Typography
            className="blue-color fs12 txt-semi-bold underline cursor pos-absolute r0"
            onClick={() => setInstModVsble(true)}
          >
            View Updates
          </Typography>
        </div> */}
        {/* {(inpatientSummary ?? [])?.map((inp) => {
          return (
            <Card
              sx={{ borderColor: "#FFFFFF", padding: 2 }}
              key={inp?.summaryId}
              className=" mt15"
            >
              <div className="flex-row">
                <div className="w70Per">
                  <Typography className="blue-color fs14 font-bold">
                    // {getVetName(inp?.doctorId, true) ? "Dr " : ""}
                    {getRightSaluation(clinicVets, inp?.doctorId)}
                    {getVetName(inp?.doctorId)}
                  </Typography>
                  <Typography className="gray13 fs10 font-medium">
                    {moment(inp?.createdDate).format("DD MMM YYYY | HH:mm")}
                  </Typography>
                </div>
                <div className="w30Per">
                  <div className="flex1-end">
                    {inp?.doctorId === petAndApntData?.appointment?.doctorId ? (
                      <Typography className="dark-red fs10 font-bold org-back ph15 pv5 br5">
                        Attending Vet’s Instructions
                      </Typography>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="flex-row mt5">
                <div className="w90Per">
                  <Typography className="black29 fs14 txt-regular">
                    {inp?.instructions}
                  </Typography>
                </div>
                <div className="flex1-end">
                  <img
                    src={require("../../../../assets/images/png/edit-new.png")}
                    alt=""
                    className="img-wh20 cursor"
                    onClick={() => handleAddUpdateInstructions(inp)}
                  />
                </div>
              </div>
            </Card>
          );
        })} */}
        {/* <div
          className="flex-row-ali-cen cursor mt20"
          onClick={() => handleAddUpdateInstructions(null)}
        >
          <div className="flex-center plus-icon">
            <AddIcon sx={addIcon} />
          </div>
          <Typography className="blue-color fs16 ml5 font-bold">Add</Typography>
        </div> */}
      </Grid>

      <CustomModal
        open={modVsble}
        onClose={onCloseMod}
        header="Instruction"
        modal
        modalWidth={40}
        headerBold
      >
        <Grid container spacing={1} className="ph20">
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <CustomTextField
              name="instruction"
              fullWidth
              handleChange={(e) => setText(e?.target?.value)}
              value={text}
              multiline
            />
          </Grid>
          <div className="flex1-end mt20 mb10">
            <div>
              <CustomButton text="Submit" onClick={handleSend} smallBtn />
            </div>
          </div>
        </Grid>
      </CustomModal>

      <CustomModal
        open={instModVsble}
        onClose={() => setInstModVsble(false)}
        header="Instruction Status"
        modal
        modalWidth={40}
        headerCenter
      >
        <div className="scroll-50vh">
          {reqDet?.inpatientNotes?.filter(
            (li) =>
              li?.appointmentId === reqDet?.appointment?.appointmentId &&
              li?.type?.toLowerCase() === "inpatient" &&
              li?.instructionsStatus?.length > 0,
          )?.length > 0 ? (
            <div className="timeline-container">
              <div className="timeline-line" />
              <div className="tasks-container">
                {reqDet?.inpatientNotes
                  ?.filter(
                    (li) =>
                      li?.appointmentId ===
                        petAndApntData?.appointment?.appointmentId &&
                      li?.type?.toLowerCase() === "inpatient" &&
                      li?.instructionsStatus?.length > 0,
                  )
                  ?.map((li) => (
                    <div key={li?.noteId}>
                      <div className="flex-row mv10">
                        <div className="tsk-gry-dot" />
                        <div className="gray37 fs12 txt-semi-bold con-fit ml20 tsk-gry-time">
                          {moment(li?.createdDate).format("DD MMM YYYY, HH:mm")}
                        </div>
                      </div>
                      <Typography className="ml20 txt-semi-bold fs14 black7 mt10">
                        {li?.instructionsStatus}
                      </Typography>
                      <Typography className="ml20 font-medium fs12 gray11 mt5">
                        {li?.userName}
                      </Typography>
                    </div>
                  ))}
              </div>
            </div>
          ) : (
            <div className="no-rec">No records available</div>
          )}
        </div>
      </CustomModal>
    </>
  );
};

export default Instructions;
